import { render, staticRenderFns } from "./Quotation_detail_shop.vue?vue&type=template&id=ff4fe218&scoped=true&"
import script from "./Quotation_detail_shop.vue?vue&type=script&lang=js&"
export * from "./Quotation_detail_shop.vue?vue&type=script&lang=js&"
import style0 from "./Quotation_detail_shop.vue?vue&type=style&index=0&id=ff4fe218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4fe218",
  null
  
)

export default component.exports